import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "what-input";
import "./polyfills";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import { BreakpointObserver } from "./breakpoints";

var toPascalCase = function toPascalCase(str) {
  return upperFirst(camelCase(str));
};

var getDataAttributes = function getDataAttributes(el) {
  if (!el) {
    return {};
  }

  var attributes = _objectSpread({}, el.dataset);

  Object.keys(attributes).forEach(function (key) {
    attributes[key] = normalizeData(attributes[key]);
  });
  return attributes;
};

var filterArrayByWhitelist = function filterArrayByWhitelist(arr, whitelistArr) {
  var dedupedArr = _toConsumableArray(new Set(arr));

  return dedupedArr.filter(function (item) {
    return whitelistArr.includes(item);
  });
};

function normalizeData(val) {
  if (val === "true") {
    return true;
  }

  if (val === "false") {
    return false;
  }

  if (val === Number(val).toString()) {
    return Number(val);
  }

  if (val === "" || val === "null") {
    return null;
  }

  return val;
}

var addClass = function addClass(el, name) {
  return el && !el.classList.contains(name) && el.classList.add(name);
};

var removeClass = function removeClass(el, name) {
  return el && el.classList.contains(name) && el.classList.remove(name);
};

var staggerTransitions = function staggerTransitions(elsList) {
  var staggerAmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.05;

  _toConsumableArray(elsList).forEach(function (el, index) {
    return el.style.transitionDelay = "".concat(staggerAmt * index, "s");
  });
};

var breakpoints = new BreakpointObserver();
export { toPascalCase, getDataAttributes, filterArrayByWhitelist, addClass, removeClass, breakpoints, staggerTransitions };